import RelatorioEmDesenvolvimento from "../../../components/RelatorioEmDesenvolvimento";

const MapaProdTalhao = () => (
  <RelatorioEmDesenvolvimento
    titulo="Mapa de Produtividade por Talhão"
    descricao="Vai depender de georreferenciamento de talhões, que ainda não existe no sistema."
  />
);

export default MapaProdTalhao;
